import { render, staticRenderFns } from "./ProjectCloner.vue?vue&type=template&id=cf524010"
import script from "./ProjectCloner.vue?vue&type=script&lang=ts"
export * from "./ProjectCloner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports